var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "task-config-container",
      on: { "tab-click": _vm.handleTabChange },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: { label: "客诉券限制配置", name: "customerCouponConfig" },
            },
            [_c("customerCouponConfig")],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "客诉券额度配置", name: "customerCouponRule" } },
            [
              _c("customerCouponRule", {
                attrs: { refresh: _vm.refresh },
                on: {
                  couponRuleAdd: _vm.couponRuleAdd,
                  handleEdit: _vm.handleEdit,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: { label: "门店额度列表", name: "customerCouponStoreNum" },
            },
            [
              _c("customerCouponStoreNum", {
                attrs: { refresh: _vm.refresh },
                on: {
                  couponSendLog: _vm.couponSendLog,
                  couponSendLogInfo: _vm.couponSendLogInfo,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeTab == "couponRuleAdd"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "添加规则", name: "couponRuleAdd" } },
                [
                  _c("couponRuleAdd", {
                    attrs: {
                      activeTab: _vm.activeTab,
                      ruleId: String(_vm.ruleId),
                    },
                    on: { saved: _vm.saved },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "电子券发放记录", name: "customerCouponeSend" } },
            [
              _c("customerCouponeSend", {
                attrs: { storeName: _vm.storeName },
                on: {
                  customerCouponeRecordUsed: _vm.customerCouponeRecordUsed,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: "电子券领取明细",
                name: "customerCouponeRecordUsed",
              },
            },
            [
              _c("customerCouponeRecordUsed", {
                attrs: { issueCode: _vm.issueCode },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: "纸质券发放记录",
                name: "customerPaperCouponeSend",
              },
            },
            [
              _c("customerPaperCouponeSend", {
                attrs: { refresh: _vm.refresh },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }